import FieldSetEditComponent from './FieldSetEdit/FieldSetEdit'
import TableEditComponent from './TableEdit/TableEdit'
import CatalogoComponent from './Catalogo/Catalogo'
import CatalogosComponent from './Catalogos/Catalogos'
import ParagraphEditComponent from './ParagraphEdit/ParagraphEdit'
import DatasourcesComponent from './Datasources/Datasources'
import ValidationComponent from './Validation/Validation'
import VisibilityComponent from './Validation/Visibility'
import SubsectionEditComponent from './SubsectionEdit/SubsectionEdit'
import TextEditComponent from './TextEdit/TextEdit'
import DecisionEditComponent from './DecisionEdit/DecisionEdit'
import TextAreaEditComponent from './TextAreaEdit/TextAreaEdit'

export const FieldSetEdit = FieldSetEditComponent
export const TableEdit = TableEditComponent
export const Catalogo = CatalogoComponent
export const Catalogos = CatalogosComponent
export const ParagraphEdit = ParagraphEditComponent
export const Datasources = DatasourcesComponent
export const Validation = ValidationComponent
export const Visibility = VisibilityComponent
export const SubsectionEdit = SubsectionEditComponent
export const TextEdit = TextEditComponent
export const DecisionEdit = DecisionEditComponent
export const TextAreaEdit = TextAreaEditComponent
